interface SkipIconProps {
    seconds?: number;
    direction?: 'backward' | 'forward';
    color?: string;
    className?: string;
}

function SkipIcon({
    seconds = 15,
    direction = 'backward',
    color = 'currentColor',
    className,
}: SkipIconProps) {
    const isForward = direction === 'forward';
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <g transform={isForward ? 'matrix(-1 0 0 1 24 0)' : undefined}>
                <path d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1" />
                <path d="M3.5 3.5v4.5H8" />
            </g>
            <text
                x={isForward ? 11.5 : 12.5}
                y="15.2"
                fontSize="7.2"
                fontWeight="500"
                textAnchor="middle"
                fill={color}
                stroke="none"
            >
                {seconds}
            </text>
        </svg>
    );
}

export default SkipIcon;
